// @ts-nocheck
import React from 'react';

import { Container, Row, Col } from 'crehana-ui/GridV2';

import { benefits, planTitles } from './constants';
import ToggleItem from './components/ToggleItem';
import MobileBenefits from './components/MobileBenefits';

import { Membership } from '../../types';
import { Benefit } from './types';

const BenefitsSection: React.FC<{ memberships: Membership[] }> = ({
  memberships,
}) => {
  let membershipWithHighlighted: Array<Membership>;

  memberships.forEach(membership => {
    membershipWithHighlighted = {
      ...membershipWithHighlighted,
      [membership.tag]: {
        isHighlighted: membership.isHighlighted,
        order: membership.order,
      },
    };
  });

  const benefitsWithHighlighted = benefits.map(
    (benefit): Benefit => {
      let newBenefit: Benefit = {
        title: '',
        description: '',
        FAMILIAR: {
          hasAccess: false,
          isHighlighted: false,
          order: 0,
          planName: '',
        },
        FREE_PLAN: {
          hasAccess: false,
          isHighlighted: false,
          order: 0,
          planName: '',
        },
        PREMIUM: {
          hasAccess: false,
          isHighlighted: false,
          order: 0,
          planName: '',
        },
        PREMIUM_DUO: {
          hasAccess: false,
          isHighlighted: false,
          order: 0,
          planName: '',
        },
      };

      Object.keys(benefit).forEach(key => {
        if (membershipWithHighlighted[key as keyof Object]) {
          newBenefit = {
            ...newBenefit,
            [key]: {
              ...benefit[key as keyof Object],
              ...membershipWithHighlighted[key as keyof Object],
            },
          };
        } else {
          newBenefit = { ...newBenefit, [key]: benefit[key as keyof Object] };
        }
      });

      return newBenefit;
    },
  );

  const planTitlesWithHighlighted = planTitles.map(plan =>
    membershipWithHighlighted[plan.tag as keyof Object]
      ? { ...plan, ...membershipWithHighlighted[plan.tag as keyof Object] }
      : plan,
  );

  return (
    <section className="bg-base-dark py-40 md:py-64 overflow-x-hidden">
      <Container className="text-white">
        <Row className="pb-16 md:pb-24">
          <Col xs={12} sm={12} md={4} lg={4}>
            <h2 className="font-h2">Beneficios</h2>
          </Col>
          {planTitlesWithHighlighted.map(planTitle => {
            const { order, isHighlighted, title } = planTitle;

            return (
              <Col
                xs={12}
                sm={12}
                md={2}
                lg={2}
                className="hidden md:block"
                key={order}
              >
                <h4
                  className={`font-h4 text-center ${
                    isHighlighted ? 'text-yellow-main' : ''
                  }`}
                >
                  {title}
                </h4>
              </Col>
            );
          })}
        </Row>
        <Row>
          <Col>
            {benefitsWithHighlighted.map((benefit, index) => (
              <div key={benefit?.title?.replace(' ', '-').toLowerCase()}>
                {/* mobile */}
                <MobileBenefits
                  benefit={benefit}
                  className="md:hidden py-24"
                  indexChildren={index}
                />
                {/* desktop */}
                <ToggleItem
                  indexChildren={index}
                  benefit={benefit}
                  className=" hidden md:block"
                >
                  <div className="w-4/12">
                    <p className="font-body3 pl-32 text-gray-main mt-4">
                      {benefit.description}
                    </p>
                  </div>
                </ToggleItem>
              </div>
            ))}
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default BenefitsSection;
